import { Fragment } from "react";
import Paper from "../../ui/customs/Paper";
import Select from "../../form/Select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/airbnb.css"; // hoặc style khác tùy chọn
import { QuestionTypes } from "../../../types/Question";
import { formEl } from "../constants";

type DateInputProps = {
    item: any;
    handleValue: (id: string, event: any, type: QuestionTypes) => void;
    deleteEl: (uuid: {id: string, uid: string}) => void;
    handleRequired: (id: string) => void;
    handleElType: (id: string, value: QuestionTypes) => void;
    handleDate: (id: string, date: Date | null) => void;
    duplicateElement: (id: string, type: QuestionTypes) => void;
};

const DateInput: React.FC<DateInputProps> = ({
                                                 item,
                                                 handleValue,
                                                 handleElType,
                                                 handleDate,
                                             }) => {
    return (
        <Fragment>
            <Paper className="p-4 bg-white rounded shadow space-y-4">
                <div className="flex flex-col md:flex-row gap-4">
                    <div className="flex-1 space-y-3">
                        <input
                            type="text"
                            defaultValue={item.value}
                            onBlur={(e) =>
                                handleValue(item.id, e, QuestionTypes.QUESTION_TYPE_SHORT_ANSWER)
                            }
                            required={item.required}
                            placeholder="Date label"
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />

                        <Flatpickr
                            value={item.date}
                            onChange={(selectedDates: Date[]) =>
                                handleDate(item.id, selectedDates[0] || null)
                            }
                            options={{ dateFormat: "Y-m-d" }}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Chọn ngày"
                        />
                    </div>

                    <div className="w-full md:w-1/4">
                        <Select
                            options={formEl.map((el) => ({ label: el.label, value: el.value.toString() }))}
                            onChange={(value) =>
                                handleElType(item.id, Number(value) as QuestionTypes)
                            }
                            defaultValue={item.type}
                        />
                    </div>
                </div>
            </Paper>
        </Fragment>
    );
};

export default DateInput;
